const WORDS = ["AI Automation", "Voice Agents", "Machine Learning", "CRM Portals", "Web Development", "Mobile Apps", "Process Automation", "Generative AI", "Data Intelligence", "Digital Transformation"];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div
      className="relative py-10 border-y border-white/10 overflow-hidden"
      data-testid="marquee"
      style={{ background: "linear-gradient(90deg, rgba(0,229,255,0.06), rgba(123,97,255,0.06), rgba(0,255,178,0.06))" }}
    >
      <div className="marquee-track gap-10">
        {row.map((w, i) => (
          <div key={i} className="flex items-center gap-10 shrink-0">
            <span
              className={`font-display text-4xl md:text-6xl font-bold ${i % 2 === 0 ? "text-gradient" : "text-white/85"}`}
            >
              {w}
            </span>
            <span className="text-[#00FFB2] text-2xl drop-shadow-[0_0_8px_rgba(0,255,178,0.7)]">✦</span>
          </div>
        ))}
      </div>
      {/* edge fades */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0B1220] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0B1220] to-transparent" />
    </div>
  );
}
